var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermissionCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 592,
    height: 640,
    viewBox: "0 0 592 640",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 296,
    cy: 320,
    r: 174.545,
    fill: "#EAECF0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.727,
    cy: 189.091,
    r: 17.4545,
    fill: "#F2F4F7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 488,
    cy: 420.364,
    r: 13.0909,
    fill: "#F2F4F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.545,
    cy: 446.546,
    r: 21.8182,
    fill: "#F2F4F7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 514.182,
    cy: 245.818,
    r: 21.8182,
    fill: "#F2F4F7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 472.727,
    cy: 169.454,
    r: 15.2727,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1607_261753)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.605 180.364C267.09 180.364 234.789 198.408 215.132 226.066C208.713 224.552 202.019 223.751 195.138 223.751C147.214 223.751 108.364 262.601 108.364 310.525C108.364 358.449 147.214 397.299 195.138 397.299L195.211 397.299H411.954C411.993 397.299 412.033 397.299 412.073 397.299C454.006 397.299 488 363.305 488 321.372C488 279.438 454.006 245.444 412.073 245.444C409.094 245.444 406.156 245.616 403.267 245.95C386.645 207.371 348.279 180.364 303.605 180.364Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.138,
    cy: 310.525,
    r: 86.774,
    fill: "url(#paint0_linear_1607_261753)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.605,
    cy: 288.831,
    r: 108.468,
    fill: "url(#paint1_linear_1607_261753)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.073,
    cy: 321.372,
    r: 75.9273,
    fill: "url(#paint2_linear_1607_261753)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1607_261753)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.909,
    y: 328.728,
    width: 122.182,
    height: 122.182,
    rx: 61.0909,
    fill: "#344054",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.455 400L320.182 412.727M320.182 400L307.455 412.727M296 398.727H284.545C280.993 398.727 279.217 398.727 277.772 399.166C274.517 400.153 271.971 402.699 270.984 405.954C270.545 407.399 270.545 409.175 270.545 412.727M302.364 378.364C302.364 384.69 297.235 389.818 290.909 389.818C284.583 389.818 279.455 384.69 279.455 378.364C279.455 372.038 284.583 366.909 290.909 366.909C297.235 366.909 302.364 372.038 302.364 378.364Z",
    stroke: "white",
    strokeWidth: 4.36364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1607_261753",
    x: 88.3636,
    y: 180.364,
    width: 419.636,
    height: 256.935,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1607_261753"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1607_261753"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1607_261753"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1607_261753",
    result: "effect2_dropShadow_1607_261753"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1607_261753",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1607_261753",
    x: 226.909,
    y: 320.728,
    width: 138.182,
    height: 138.182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1607_261753"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1607_261753",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1607_261753",
    x1: 128.508,
    y1: 253.192,
    x2: 281.912,
    y2: 397.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1607_261753",
    x1: 220.318,
    y1: 217.165,
    x2: 412.073,
    y2: 397.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1607_261753",
    x1: 353.771,
    y1: 271.205,
    x2: 488,
    y2: 397.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionCloud);
export default __webpack_public_path__ + "static/media/permission-cloud.07a6c5f70484a8b0223c2747d50bfc01.svg";
export { ForwardRef as ReactComponent };